import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { smsOutboxActions } from "../slices/smsOutbox";
import { getErrorMessage } from "../../utils/errorUtils";

import { SmsManualRequestDto } from "../../shared/dtos/sms/SmsManualRequestDto";
import { SmsOutboxResponseDto } from "../../shared/dtos/sms/SmsOutboxResponseDto";
import { SmsOutboxQueryDto } from "../../shared/dtos/sms/SmsOutboxQueryDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { PaginatedResponse } from "../../shared/dtos/common/PaginatedResponse";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getOutbox =
  (filters: SmsOutboxQueryDto = {}) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(smsOutboxActions.setLoading());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<PaginatedResponse<SmsOutboxResponseDto>>
      >("/sms/outbox", {
        headers: { requiresAuth: true },
        params: filters,
      });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(smsOutboxActions.setItems(data.data.content));
        dispatch(smsOutboxActions.setPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(smsOutboxActions.setError(getErrorMessage(error)));
    }
  };

export const sendManualSms =
  (values: SmsManualRequestDto) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(smsOutboxActions.setLoadingSendManual());
    try {
      const { data } = await axiosInstance.post<ApiResponseDto<void>>(
        "/sms/outbox/manual",
        values,
        {
          headers: { requiresAuth: true },
        },
      );
      if (data.status === ApiResponseStatus.SUCCESS) {
        toast.success(data.message || "SMS queued successfully!");
        dispatch(smsOutboxActions.sendManualSmsSuccess());
        dispatch(
          smsOutboxActions.setServerStatus({
            operation: "create",
            status: data.statusCode || 201,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(smsOutboxActions.setErrorSendManual(message));
    }
  };

export const resetSmsOutboxServerStatus = () => (dispatch: AppDispatch) =>
  dispatch(smsOutboxActions.setServerStatus(null));
